import {
	CountryCode,
	Locales,
	UsePhoneInputOptions,
	UsePhoneInputReturn,
	usePhoneInput,
} from "@caspeco/casper-ui-library";
import { useUserContext } from "./use-user-context";

const toPhoneInputCountry = (localeString: Locales): CountryCode | undefined => {
	return localeString.split("-")[1] as CountryCode | undefined;
};

/**
 * Wraps `usePhoneInput`, defaulting `locale` and `defaultCountry` to MyPages' currently
 * selected locale (userLocale) rather than the library's own browser-language detection.
 */
export const useLocalePhoneInput = (
	options?: Omit<UsePhoneInputOptions, "locale" | "defaultCountry">,
): UsePhoneInputReturn => {
	const { userLocale } = useUserContext();

	const phone = usePhoneInput({
		...options,
		locale: userLocale.localeString,
		defaultCountry: toPhoneInputCountry(userLocale.localeString),
	});

	// An empty number is valid when the field isn't required; kept consistent between isValid and validate().
	const isEmptyAndOptional = !options?.isRequired && phone.e164 === "";

	return {
		...phone,
		isValid: phone.isValid || isEmptyAndOptional,
		validate: () => (isEmptyAndOptional ? { isValid: true } : phone.validate()),
	};
};
